import React from 'react'

const Loading = () => {
  return (
    <div className="loading-holder">
      <div className="loading-shape-1 counter-rotate"></div>
      <div className="loading-shape-2 rotate"></div>
      <div className="loading-shape-3 counter-rotate"></div>
      <div className="loading-shape-4 rotate"></div>
    </div>
  )
}

export default Loading



// WEBPACK FOOTER //
// ./assets/js/components/static/Loading.jsx